module.exports = __webpack_public_path__ + "img/01.8f792560.png";